import React, { useContext, useEffect, useState } from "react";
import { CartContext } from "../context/CartContext";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { LoginContext } from "../context/LoginContext";
import Modal from "react-bootstrap/Modal";
import "./css/Products.css";

const AddToCart = (props) => {
  const cartItem = useContext(CartContext);

  const [type, setType] = useState(true);

  const [tedadInput, setTedadInput] = useState("");

  const [sizeInput, setSizeInput] = useState("");

  const [vaznInput, setVaznInput] = useState("");

  const [tedadiInfoInput, setTedadiInfoInput] = useState("");

  const [vazniInfoInput, setVazniInfoInput] = useState("");

  const [tedadiInfoBtn, setTedadiInfoBtn] = useState(false);

  const [vazniInfoBtn, setVazniInfoBtn] = useState(false);

  const [showInfoTedadi, setShowInfoTedadi] = useState(false);

  const [showInfoVazni, setShowInfoVazni] = useState(false);

  const login = useContext(LoginContext);

  // useEffect(()=>{
  //   if(isQuick){
  //     tedad
  //   }

  // } , [isQuick]);

  useEffect(() => {
    const index = findItem();
    if (index === -1) {
      setTedadiInfoBtn(false);
      setVazniInfoBtn(false);
    } else {
      setTedadiInfoBtn(true);
      setVazniInfoBtn(true);
      const item = cartItem.items[index];
      if (item.type === "vazni") {
        setVazniInfoInput(item.value.split("#")[1]);
      } else {
        setTedadiInfoInput(item.value.split("#")[1]);
      }
    }
  }, [cartItem.items]);

  const changeType = () => {
    if (findItem() !== -1) {
      return;
    }
    setType(!type);
  };

  const tedadHandle = (event) => {
    if (isNaN(event.target.value)) {
      return;
    }
    setTedadInput(event.target.value);
  };

  const quickSale = (product) => {
    if (parseInt(product.vazn) <= 0) {
      return;
    }
    const exist = findItem();
    if (exist !== -1) {
      const info = cartItem.items[exist].value.split("#")[1];
      const sprateArray = cartItem.items[exist].value.split("#")[0].split("@");
      const size = sizeInput === "" ? 0 : sizeInput;
      const sizeIndex = sprateArray.findIndex((item) => {
        return parseInt(item.split("~")[1]) === parseInt(size);
      });
      if (sizeIndex !== -1) {
        return;
        // const val =
        //   parseInt(1) +
        //   parseInt(sprateArray[sizeIndex].split("~")[0]) +
        //   "~" +
        //   (sizeInput === "" ? 0 : sizeInput + "#" + info);
        // sprateArray.splice(sizeIndex, 1, val);
        // let finalVal = "";
        // for (let index = 0; index < sprateArray.length; index++) {
        //   if (index + 1 === sprateArray.length) {
        //     finalVal = finalVal + sprateArray[index];
        //   } else {
        //     finalVal = finalVal + sprateArray[index] + "@";
        //   }
        // }
        // const newArray = sprateArray.map((item, index) => { });
        // const Item = {
        //   product: product,
        //   type: "tedadi",
        //   value: finalVal,
        // };
        // const array = [...cartItem.items];
        // array.splice(exist, 1, Item);
        // cartItem.setItems(array);
      } else {
        const val =
          cartItem.items[exist].value.split("#")[0] +
          "@" +
          1 +
          "~" +
          (sizeInput === "" ? 0 : sizeInput + "#" + info);
        const Item = {
          product: product,
          type: "tedadi",
          value: val,
        };
        const array = [...cartItem.items];
        array.splice(exist, 1, Item);
        cartItem.setItems(array);
      }
    } else {
      const Item = {
        product: product,
        type: "tedadi",
        value: "1" + "~" + (sizeInput === "" ? 0 : sizeInput) + "#",
      };
      cartItem.setItems((currentItem) => {
        return [...currentItem, Item];
      });
    }
    cartItem.setIsQuick(true);
    setSizeInput("");
    setTedadInput("");
  };

  const sizeHandle = (event) => {
    if (isNaN(event.target.value)) {
      return;
    }
    setSizeInput(event.target.value);
  };

  const vaznHandle = (event) => {
    if (isNaN(event.target.value)) {
      return;
    }
    setVaznInput(event.target.value);
  };

  const tedadiBtn = (product, isInfo = false) => {
    if (!isInfo) {
      if (tedadInput === "" || parseInt(tedadInput) === 0) {
        return;
      }

      // setTedadiInfoBtn(true);

      const exist = findItem();
      if (exist !== -1) {
        const info = cartItem.items[exist].value.split("#")[1];
        const sprateArray = cartItem.items[exist].value
          .split("#")[0]
          .split("@");
        const size = sizeInput === "" ? 0 : sizeInput;
        const sizeIndex = sprateArray.findIndex((item) => {
          return parseInt(item.split("~")[1]) === parseInt(size);
        });
        if (sizeIndex !== -1) {
          const val =
            parseInt(tedadInput) +
            parseInt(sprateArray[sizeIndex].split("~")[0]) +
            "~" +
            (sizeInput === "" ? 0 : sizeInput + "#" + info);
          sprateArray.splice(sizeIndex, 1, val);
          let finalVal = "";
          for (let index = 0; index < sprateArray.length; index++) {
            if (index + 1 === sprateArray.length) {
              finalVal = finalVal + sprateArray[index];
            } else {
              finalVal = finalVal + sprateArray[index] + "@";
            }
          }
          const newArray = sprateArray.map((item, index) => { });
          const Item = {
            product: product,
            type: "tedadi",
            value: finalVal,
          };
          const array = [...cartItem.items];
          array.splice(exist, 1, Item);
          cartItem.setItems(array);
        } else {
          const val =
            cartItem.items[exist].value.split("#")[0] +
            "@" +
            tedadInput +
            "~" +
            (sizeInput === "" ? 0 : sizeInput + "#" + info);
          const Item = {
            product: product,
            type: "tedadi",
            value: val,
          };
          const array = [...cartItem.items];
          array.splice(exist, 1, Item);
          cartItem.setItems(array);
        }
      } else {
        const Item = {
          product: product,
          type: "tedadi",
          value: tedadInput + "~" + (sizeInput === "" ? 0 : sizeInput) + "#",
        };
        cartItem.setItems((currentItem) => {
          return [...currentItem, Item];
        });
      }
      setSizeInput("");
      setTedadInput("");
    } else {
      const exist = findItem();
      if (exist !== -1) {
        const val =
          cartItem.items[exist].value.split("#")[0] + "#" + tedadiInfoInput;
        const Item = {
          product: product,
          type: "tedadi",
          value: val,
        };
        const array = [...cartItem.items];
        array.splice(exist, 1, Item);
        cartItem.setItems(array);
        setShowInfoTedadi(false);
      }
    }
  };

  const vaznBtn = (product, isInfo) => {
    if (!isInfo) {
      if (vaznInput === "" || parseInt(vaznInput) === 0) {
        return;
      }
      const Item = { product: product, type: "vazni", value: vaznInput + "#" };
      const exist = findItem();
      if (exist !== -1) {
        const array = [...cartItem.items];
        array.splice(exist, 1, Item);
        cartItem.setItems(array);
      } else {
        cartItem.setItems((currentItem) => {
          return [...currentItem, Item];
        });
      }
      setVaznInput("");
    } else {
      const exist = findItem();
      const Item = {
        product: product,
        type: "vazni",
        value: cartItem.items[exist].value.split("#")[0] + "#" + vazniInfoInput,
      };
      if (exist !== -1) {
        const array = [...cartItem.items];
        array.splice(exist, 1, Item);
        cartItem.setItems(array);
      }
      setShowInfoVazni(false);
    }
  };

  const findItem = () => {
    const index = cartItem.items.findIndex((item) => {
      return item.product.pk === props.product.pk;
    });
    return index;
  };

  const insertInfoTedadi = () => {
    setShowInfoTedadi(true);
  };

  const changeTedadiInfo = (e) => {
    setTedadiInfoInput(e.target.value);
  };

  const insertInfoVazni = () => {
    setShowInfoVazni(true);
  };

  const changeVazniInfo = (e) => {
    setVazniInfoInput(e.target.value);
  };

  if (
    login.loginState &&
    login.userInfo.dastresi !== "4" &&
    login.userInfo.dastresi !== "5"
  ) {
    if (login.userInfo.dastresi === "0" || login.userInfo.dastresi === "1") {
      return (
        <div className="text-center mt-2">
          <button
            className="btn btn-primary"
            onClick={() => {
              quickSale(props.product);
            }}
          >
            سفارش
          </button>
        </div>
      )
    } else {
      if (type) {
        return (
          <div>
            <div className="rtl form-row pt-3">
              <div className="col-4">
                <BootstrapSwitchButton
                  checked={true}
                  onlabel="تعداد"
                  offlabel="وزن"
                  onstyle="primary"
                  offstyle="success"
                  width={70}
                  onChange={changeType}
                />
              </div>
              <div className="col-3">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="4"
                  className="form-control"
                  placeholder="تعداد"
                  value={tedadInput}
                  onChange={tedadHandle}
                />
              </div>
              <div className="col-3">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="4"
                  className="form-control"
                  placeholder="سایز"
                  value={sizeInput}
                  onChange={sizeHandle}
                />
              </div>
              <div className="col-2">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    tedadiBtn(props.product);
                  }}
                >
                  <FontAwesomeIcon icon={faCartPlus} />
                </button>
              </div>
            </div>
            {tedadiInfoBtn ? (
              <div className="d-flex justify-content-center mt-3">
                <button className="btn btn-info" onClick={insertInfoTedadi}>
                  افزودن توضیحات
                </button>
              </div>
            ) : null}

            <Modal
              show={showInfoTedadi}
              onHide={() => setShowInfoTedadi(false)}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              scrollable
            >
              <Modal.Header className="rtl justify-content-center"></Modal.Header>
              <Modal.Body>
                <textarea
                  value={tedadiInfoInput}
                  onChange={changeTedadiInfo}
                  className="form-control"
                ></textarea>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-dark"
                  onClick={() => setShowInfoTedadi(false)}
                >
                  بستن
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => tedadiBtn(props.product, true)}
                >
                  ثبت
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        );
      } else {
        return (
          <div>
            <div className="rtl form-row pt-3">
              <div className="col-4">
                <BootstrapSwitchButton
                  checked={false}
                  onstyle="success"
                  onlabel="وزن"
                  offstyle="success"
                  offlabel="وزن"
                  width={70}
                  onChange={changeType}
                />
              </div>
              <div className="col-6">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="4"
                  className="form-control"
                  placeholder="وزن"
                  value={vaznInput}
                  onChange={vaznHandle}
                />
              </div>
              <div className="col-2">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    vaznBtn(props.product);
                  }}
                >
                  <FontAwesomeIcon icon={faCartPlus} />
                </button>
              </div>
            </div>
            {vazniInfoBtn ? (
              <div className="d-flex justify-content-center mt-3">
                <button className="btn btn-info" onClick={insertInfoVazni}>
                  افزودن توضیحات
                </button>
              </div>
            ) : null}

            <Modal
              show={showInfoVazni}
              onHide={() => setShowInfoVazni(false)}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              scrollable
            >
              <Modal.Header className="rtl justify-content-center"></Modal.Header>
              <Modal.Body>
                <textarea
                  value={vazniInfoInput}
                  onChange={changeVazniInfo}
                  className="form-control"
                ></textarea>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-dark"
                  onClick={() => setShowInfoVazni(false)}
                >
                  بستن
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => vaznBtn(props.product, true)}
                >
                  ثبت
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        );
      }
    }
  } else {
    return null;
  }
};

export default AddToCart;
